<app-modal
  [title]="'Voucher Details' | trans:'vouchers/voucher-details-modal/header/title'"
  [compact]="true"
  maxWidth="1200px"
>
  <ng-template>
    @if (voucherDetails()) {
      <div class="m-b-16">
        <app-toggle-tabs-menu
          [options]="tabOptions"
          [selectedIndex]="selectedTabIndex()"
          (selectedIndexChange)="onTabChange($event)"
        />
      </div>

      @if (selectedTabIndex() === 0) {
        <table class="base full-width wrap">
          <tbody>
            <tr>
              <td>
                <div>
                  {{ 'Voucher Number' | trans:'vouchers/voucher-details-modal/voucher-number.Label' }}:
                </div>
              </td>
              <td>
                <div>
                  {{ voucherDetails()!.voucherNumber }}
                </div>
              </td>
              <td>
                <div>
                  {{ 'Name' | trans:'vouchers/voucher-details-modal/name.Label' }}:
                </div>
              </td>
              <td>
                <div>
                  {{ voucherDetails()!.name }}
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <div>
                  {{ 'Balance' | trans:'vouchers/voucher-details-modal/balance.Label' }}:
                </div>
              </td>
              <td>
                <div>
                  {{ voucherDetails()!.balance | numberToCurrency }} {{ languageConfig.currency.short }}
                </div>
              </td>
              <td>
                <div>
                  {{ 'Status' | trans:'vouchers/voucher-details-modal/status.Label' }}:
                </div>
              </td>
              <td>
                <div>
                  <div
                    class="voucher-status voucher-status--{{ voucherDetails()!.status }}"
                  >
                    {{ voucherDetails()!.status | trans:'vouchers/voucher-details-modal/status/' + voucherDetails()!.status }}
                  </div>
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <div>
                  {{ 'Valid Until' | trans:'vouchers/voucher-details-modal/valid-until.Label' }}:
                </div>
              </td>
              <td>
                <div>
                  {{ voucherDetails()!.validUntil | localeDatetimeFormat }}
                </div>
              </td>
              @if (voucherDetails()!.cancelInfo) {
                <td>
                  <div>
                    {{ 'Cancel Info' | trans:'vouchers/voucher-details-modal/cancel-info.Label' }}:
                  </div>
                </td>
                <td>
                  <div>
                    {{ voucherDetails()!.cancelInfo }}
                  </div>
                </td>
              } @else {
                <td><div></div></td>
                <td><div></div></td>
              }
            </tr>
          </tbody>
        </table>
      }

      @if (selectedTabIndex() === 1) {
        @if (voucherTransactions().length === 0) {
          <div class="text-center p-24">
            {{ 'No transactions found' | trans:'vouchers/voucher-details-modal/transactions/no-transactions' }}
          </div>
        } @else {
          <table class="base full-width wrap">
            <thead>
              <tr>
                <th>
                  {{ 'Date' | trans:'vouchers/voucher-details-modal/transactions/date.Label' }}
                </th>
                <th>
                  {{ 'Type' | trans:'vouchers/voucher-details-modal/transactions/type.Label' }}
                </th>
                <th>
                  {{ 'Amount' | trans:'vouchers/voucher-details-modal/transactions/amount.Label' }}
                </th>
              </tr>
            </thead>
            <tbody>
              @for (transaction of voucherTransactions(); track transaction.id) {
                <tr>
                  <td>
                    <div>
                      {{ transaction.date | localeDatetimeFormat }}
                    </div>
                  </td>
                  <td>
                    <div>
                      {{ transaction.transactionType }}
                    </div>
                  </td>
                  <td>
                    <div>
                      {{ transaction.amount | numberToCurrency }} {{ languageConfig.currency.short }}
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      }
    }
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-space-between">
      <button
        class="button button--md button--primary text-uppercase"
        [disabled]="!voucherDetails()?.voucherId || isPrinting()"
        (click)="reprintVoucher()"
      >
        {{ 'Reprint Voucher' | trans:'vouchers/voucher-details-modal/reprint-voucher.Button' }}
      </button>
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'Close' | trans:'vouchers/voucher-details-modal/close.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>
